import { useEffect } from 'react'
import { useParams,useNavigate } from 'react-router-dom'
import { post } from '../../../utils/axios'
import { Alert } from '@mui/material'
import { toast } from 'react-toastify'

const Callback = () => {

    const { guid } = useParams()
    const navigate = useNavigate()

    useEffect(() => {
        if(guid){
            const postedData = {
                code: guid
            }
            post('Payment/ValidateCode',postedData).then(({ data }) => {
                if(guid && data.isSuccess)
                    toast.success('پرداخت شما با موفقیت انجام شد')
                else
                    toast.error(data?.data?.message || 'پرداخت شما ناموفق بود')
                navigate('/app')
            })
        }else{
            toast.error('پرداخت شما ناموفق بود')
            navigate('/app')
        }
    },[])

    return (
        <Alert severity="info">در حال دریافت اطلاعات تراکنش شما ...</Alert>
    )
}

export default Callback